<template>
  <el-dialog
    v-if="visibles"
    v-el-drag-dialog
    :visible.sync="visibles"
    :before-close="closeDialog"
    :close-on-click-modal="false"
    :lock-scroll="false"
    :destroy-on-close="true"
    append-to-body
    :show-close="false"
    width="62.5%"
    center
  >
    <dialog-header
      slot="title"
      :title="$t('carMonitor.terminalBatch.obdTaskDetail')"
      :icon="'icon-dialog-add'"
      @close="closeDialog"
    />
    <app-search>
      <div slot="content">
        <el-row :gutter="10" type="flex" justify="start" align="middle">
          <el-col :span="8">
            <el-form :label-position="'right'" :model="listQuery" label-width="90px">
              <el-form-item :label="$t('public.obdCode')+'：'">
                <el-input
                  v-model="listQuery.barcode"
                  :placeholder="$t('public.obdCode')"
                  clearable
                />
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="8">
            <el-form :label-position="'right'" :model="listQuery" label-width="90px">
              <el-form-item :label="$t('carMonitor.terminalBatch.wancheng')+'：'">
                <el-select v-model="listQuery.status" clearable multiple :placeholder="$t('carMonitor.terminalBatch.wancheng')">
                    <el-option
                      v-for="item in statusList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                </el-select>                
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
        <el-row v-if="collapse" style="margin-top:10px; margin-bottom: 42px;"  type="flex" justify="start" align="middle">
          <el-col :span="16">
            <el-form
              :label-position="'right'"
              :model="listQuery"
              label-width="80px"
            >
              <el-form-item :label="$t('public.startTime')+'：'">
                <el-row type="flex" justify="start" align="middle">
                  <el-col :span="12">
                    <el-date-picker
                      v-model="listQuery.startTime"
                      filterable
                      clearable
                      :placeholder="$t('public.startTime')"
                      type="datetime"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      prefix-icon="el-icon-date"
                    />
                  </el-col>
                  &emsp;<span class="time-span" style="color:#ddd;">——</span>&emsp;
                  <el-col :span="12">
                    <el-date-picker
                      v-model="listQuery.endTime"
                      filterable
                      clearable
                      :placeholder="$t('public.endTime')"
                      type="datetime"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      prefix-icon="el-icon-date"
                    />
                  </el-col>
                </el-row>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </div>
      <app-search-button
        slot="bottom"
        @click-collapse="handleCollapse"
        @click-filter="handleFilter"
        @click-clear="restData"
      />
    </app-search>

    <!-- table -->
    <div style="min-height:40vh">
      <el-table
        ref="tableList"
        show-overflow-tooltip
        v-loading="listLoading"
        size="mini"
        :data="list"
        :max-height="tableHeight"
        :header-row-style="headerRowStyle"
        :row-style="rowStyle"
        :header-cell-style="headerCellStyle"
        border
        fit
        highlight-current-row
        style="width: 100%"
        @sort-change="sortChange"
      >
        <el-table-column :label="$t('table.id')" align="center" width="65">
          <template slot-scope="scope">
            <span>{{ (scope.$index+1)+(listQuery.pageNum -1)*listQuery.pageSize }}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-for="(item,index) in filterTableList"
          :key="index"
          :label="item.value"
          :prop="item.prop"
          :align="item.position"
          :min-width="item.width"
          :sortable="item.sortable">
          <template slot-scope="scope">
            
            <div>{{ scope.row[item.prop] ||  (scope.row[item.prop]===0?scope.row[item.prop]: '/') }}</div>
          </template>
        </el-table-column>
      </el-table>
       <!-- 分页 -->
    <div :class="[total>0?'visible':'hidden','pagination-container']">
      <el-pagination
        :current-page="listQuery.pageNum"
        :page-sizes="[10,20,30,50]"
        :page-size="listQuery.pageSize"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    </div>
  </el-dialog>
</template>

<script>
// 混入
import { pagingMixin } from "@/mixins/table"
import { tableStyle } from "@/mixins/tableStyle"
// request
import { getBarcodePageList } from '@/api/carMonitor/terminalBatch'

export default {
  name:"LookObdDialog",
  mixins: [pagingMixin, tableStyle],
  props: {
    visibles: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      listQuery: {
        barcode: "",
        status:[]
      },
      showfilter: false,
      list: [],
      total: 0,
      tableHeight: 0,
      listLoading: false,
      tableList: [
        {
          value: this.$t("public.obdCode"),
          prop: "barcode",
          width: 150,
          position: "center",
          sortable: 'custom',
          checked:true
        },
        {
          value: this.$t("carMonitor.terminalBatch.taskName"),
          prop: "packname",
          width: 150,
          position: "center",
          sortable: 'custom',
          checked:true
        },
        {
          value: this.$t("carMonitor.terminalBatch.wancheng"),
          prop: "status",
          width: 150,
          position: "center",
          sortable: 'custom',
          checked:true
        },
        {
          value: this.$t("carMonitor.terminalBatch.createtime"),
          prop: "startTime",
          width: 120,
          position: "center",
          sortable: 'custom',
          checked:true
        },
        {
          value: this.$t("public.endTime"),
          prop: "endTime",
          width: 120,
          position: "center",
          sortable: 'custom',
          checked:true
        }
      ],
      lookObdTaskVisible:false,
      statusList:[
        {label:vm.$t("carMonitor.terminalBatch.yichexiao"),value:-1},
        {label:vm.$t("carMonitor.terminalBatch.notperformed"),value:0},
        {label:vm.$t("carMonitor.terminalBatch.Inprogress"),value:1},
        {label:vm.$t("carMonitor.terminalBatch.Finishedperformed"),value:2},
        {label:vm.$t("carMonitor.terminalBatch.failedcount"),value:3},
        {label:vm.$t("carMonitor.terminalBatch.tingzx"),value:4}
      ]
    }
  },
  watch: {
    visibles(e1) {
      if (e1) {
        this.listLoad()
      }
    },
  },
  computed: {
    filterTableList() {
      return this.tableList.filter(item => item.checked)
    },
    lang() {
      return this.$store.getters.language
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.tableHeight = window.innerHeight * 0.5
    })
    window.onresize = () => {
      this.$nextTick(() => {
        this.tableHeight = window.innerHeight * 0.5
      })
    }
  },
  methods:{
    //加载数据
    listLoad(){
      if (!this.visibles) {
        return
      }
      this.listLoading=true
      getBarcodePageList(this.listQuery).then(({data})=>{
          this.list = []
          if(data.code==0){
              this.list=data.data
              this.total=data.total
          }
          this.listLoading = false
      }).catch(()=>{
        this.listLoading = false})
    },
    //重置数据
    restData(){
      this.total=0
      this.listQuery.barcode=''
      this.listQuery.status=[]
      this.listQuery.startTime=''
      this.listQuery.endTime=''
    },
    closeDialog(){
      this.restData()
      this.$emit('update:visibles', false)
    }
  }
}
</script>
<style lang="scss" scoped>
.yesgps {
  color: rgb(64, 109, 64);
}
.nogps {
  color: #98a3af;
}
.borderBottom {
  border-bottom: 1px solid rgb(96, 98, 102);
  cursor: pointer;
}
.custom-button:hover{
  background: #fff !important;
}
</style>